import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import RCG from 'react-captcha-generator';

import { Checkbox,Icon,TextField } from 'component-lib';
import Vas from '../Vas';

import '../css/CaptchaBox.css';
/*
Pflichtproperties:
 Id={"ceckboxAGB"} 
 onClick={()=>{this.setState({AGB:$("#ceckboxAGB").val()})}}
label={}

optional:
ref={"AGB"}
name={}
value={}
Float={}
*/

var rcg;
var captchaIcon;
var captcha = '';
var captchaTextBox;

// eslint-disable-next-line react/prefer-stateless-function
class CaptchaBox extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.state.IsRequired = this.props.IsRequired !== undefined ? this.props.IsRequired : true;
        this.state.Label=this.props.Label !== undefined ? this.props.Label : Vas.Resources.Labels["Captcha"];
        this.check = this.check.bind(this);
        this.result = this.result.bind(this);
        this.state.Valid = false;
    }

    componentDidMount(){
      this.setState({ RCG : rcg, CaptchaIcon: captchaIcon, CaptchaTextBox : captchaTextBox },()=>{
        rcg.setData();
      });
    }

    returnValid(){
        return this.state.Valid;
    }

    returnTextBox(){
        return this.state.CaptchaTextBox;
    }

    result(text) {//legt den Captchatext in den State
        this.setState({ captcha: text });
    }

    check() { // prüft ob eingegebener Wert  = Captchawert
        if (this.state.captcha !== document.getElementById("captcha").value){
            this.reset();//wenn falser Wert eingebene wird -Y Captcha erhält neue Zeichenfolge
            this.setState({ Valid:false });
        } else {
            this.state.CaptchaIcon.setState({ Name:"Done",Color:"green" });
            this.setState({ captcha:document.getElementById("captcha").value, Valid:true });
        }
    }

    reset(){ // mach eine neue Captcha Zeichenfolge
        this.state.CaptchaIcon.setState({ Name:"Warning",Color:"red" });
        this.state.RCG.setData();//setzte neue Zeichenfolge
        document.getElementById("captcha").value="";//leert das Eingabefeld
        this.setState({ Valid:false });
    }

    showCaptcha(){

        if (document.getElementById(this.props.Id).checked === true) {

            if (this.state.IsRequired === true){
                captcha = (<TextField
                  AppURL={Vas.ApplicationUrl}
                  IsRequired={true}
                  Id="captcha"
                  Width={170}
                  Editable={true}
                  Label={Vas.Resources.Labels["CheckWord"] + "*"}
                  Tooltip={Vas.Resources.Tooltips["RCG"]}
                  OnBlur={()=>{this.check();}}
                  ref={inst => {captchaTextBox = inst;}} />);
            } else {
                captcha = (<TextField
                  AppURL={Vas.ApplicationUrl}
                  IsRequired={false}
                  Id="captcha"
                  Width={170}
                  Editable={true}
                  Label={Vas.Resources.Labels["CheckWord"]}
                  Tooltip={Vas.Resources.Tooltips["RCG"]}
                  OnBlur={()=>{this.check();}}
                  ref={inst => {captchaTextBox = inst;}} />);
            }
            
            ReactDOM.render(
              <table className={"CaptchaBox"}>
                <tbody>
                  <tr>
                    <td><RCG
                      result={this.result}
                                //ref={"RCG"} 
                      ref={inst => {rcg = inst;}}
                      height={50}
                      paddingTop={40} /></td>
                    <td style={{paddingTop:'20px'}}><Icon
                      Name={"Loop"}
                      Size={24}
                      Color={"black"}
                      Align={"left"}
                      OnClick={()=>{this.reset();}} />
                    </td>
                  </tr>
                  <tr>
                    <td>{captcha}<br /></td>
                    <td style={{ paddingTop:'5px' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{paddingTop:'20px'}}><Icon
                              Id={"ChaptchaIcon"}
                                                //ref={"ChaptchaIcon"}
                              ref={inst => {captchaIcon = inst;}}
                              Name={"Warning"}
                              Size={24}
                              Color={"red"}
                              Align={"left"} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>  
                </tbody>
              </table>
                
                , document.getElementById('RCGArea')
            );

            this.setState({ RCG : rcg, CaptchaIcon: captchaIcon, CaptchaTextBox : captchaTextBox },()=>{
                rcg.setData();
            });
        } else {
            ReactDOM.unmountComponentAtNode(document.getElementById('RCGArea'));
        }
        
    }

    render()
    {
        let label = this.state.Label;
        if (this.state.IsRequired === true) {
            label += "*";
        }
        let classLabel = '';
        if(this.props.ClassLabel){
            classLabel = this.props.ClassLabel;
        }

        if (this.state.IsRequired === true){
          captcha = (<TextField
            AppURL={Vas.ApplicationUrl}
            IsRequired={true}
            Id="captcha"
            Width={170}
            Editable={true}
            Label={Vas.Resources.Labels["CheckWord"] + "*"}
            Tooltip={Vas.Resources.Tooltips["RCG"]}
            OnBlur={()=>{this.check();}}
            ref={inst => {captchaTextBox = inst;}} />);
      } else {
          captcha = (<TextField
            AppURL={Vas.ApplicationUrl}
            IsRequired={false}
            Id="captcha"
            Width={170}
            Editable={true}
            Label={Vas.Resources.Labels["CheckWord"]}
            Tooltip={Vas.Resources.Tooltips["RCG"]}
            OnBlur={()=>{this.check();}}
            ref={inst => {captchaTextBox = inst;}} />);
      }

        return ( 
         
          <table>
            <tbody>
              <tr>
                <td></td>
                <td id={"RCGArea"}>
                <table className={"CaptchaBox"}>
                <tbody>
                  <tr>
                    <td><RCG
                      result={this.result}
                                //ref={"RCG"} 
                      ref={inst => {rcg = inst;}}
                      height={50}
                      paddingTop={40} /></td>
                    <td style={{paddingTop:'20px'}}><Icon
                      Name={"Loop"}
                      Size={24}
                      Color={"black"}
                      Align={"left"}
                      OnClick={()=>{this.reset();}} />
                    </td>
                  </tr>
                  <tr>
                    <td>{captcha}<br /></td>
                    <td style={{ paddingTop:'5px' }}>
                      <table>
                        <tbody>
                          <tr>
                            <td style={{paddingTop:'20px'}}><Icon
                              Id={"ChaptchaIcon"}
                                                //ref={"ChaptchaIcon"}
                              ref={inst => {captchaIcon = inst;}}
                              Name={"Warning"}
                              Size={24}
                              Color={"red"}
                              Align={"left"} /></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>  
                </tbody>
              </table>
                </td>
              </tr>
            </tbody>
          </table>
          );
    }
}
export default CaptchaBox;
